import { languages } from './languages.js'; // 导入语言配置

// 创建一个函数来获取当前语言的角色数据
const getCharactersData = (lang) => {
  const config = languages[lang]; // 获取语言配置
  return [
    {
      id: 1,
      image: '/images/characterBackground/thefool.png',
      title: config.characters.the_fool.title,
      background: '/images/characterBackground/thefool.png',
      personality: config.characters.the_fool.personality,
      subtitle: config.characters.the_fool.subtitle,
      description: config.characters.the_fool.description,

      colors: ["#a52837", "#e05231", "#f3dfd3", "#98a8a5", "#f88e37"],
      
      info: "the_fool.js",
      import_name: "theFool",
      dialogue_background_color: "#f3dfd3",
      avatar_image: "/images/The_fool_avatar.avif",
      emotion_guidence: config.characters.the_fool.emotion_guidence,

      intro: config.characters.the_fool.intro,
      dialogue1: config.characters.the_fool.dialogue1,
      dialogue2: config.characters.the_fool.dialogue2,
      interests: config.characters.the_fool.interests,
      type: config.characters.the_fool.type,

      fortune_dialogue: config.characters.the_fool.fortune_dialogue,
      fortune_guidence: config.characters.the_fool.fortune_guidence


    },
    {
      id: 2,
      image: '/images/characterBackground/hangman.png',
      title: config.characters.the_hanged_man.title,
      background: '/images/characterBackground/hangman.png',
      personality: config.characters.the_hanged_man.personality,
      emotion_guidence: config.characters.the_hanged_man.emotion_guidence,

      colors: ["#292e2e", "#40603a", "#e7e0d3", "#8a4731"],

      subtitle: config.characters.the_hanged_man.subtitle,
      description: config.characters.the_hanged_man.description,

      info: "the_hanged_man.js",
      import_name: "theHangedMan",
      dialogue_background_color: "#40603a",
      avatar_image: "/images/The_hanged_man_avatar.avif",

      intro: config.characters.the_hanged_man.intro,
      dialogue1: config.characters.the_hanged_man.dialogue1,
      dialogue2: config.characters.the_hanged_man.dialogue2,
      interests: config.characters.the_hanged_man.interests,
      type: config.characters.the_hanged_man.type,

      fortune_dialogue: config.characters.the_hanged_man.fortune_dialogue,
      fortune_guidence: config.characters.the_hanged_man.fortune_guidence
    },
    {
      id: 3,
      image: '/images/characterBackground/magician.png',
      title: config.characters.the_magician.title,
      background: '/images/characterBackground/magician.png',
      personality: config.characters.the_magician.personality,
      emotion_guidence: config.characters.the_magician.emotion_guidence,

      colors: ["#88839b", "#d38a85", "#e8806f", "#80d9d3", "#e1e6ab"],

      subtitle: config.characters.the_magician.subtitle,
      description: config.characters.the_magician.description,

      info: "the_magician.js",
      import_name: "theMagician",
      dialogue_background_color: "#88839B",
      avatar_image: "/images/The_magician_avatar.avif",

      intro: config.characters.the_magician.intro,
      dialogue1: config.characters.the_magician.dialogue1,
      dialogue2: config.characters.the_magician.dialogue2,
      interests: config.characters.the_magician.interests,
      type: config.characters.the_magician.type,

      fortune_dialogue: config.characters.the_magician.fortune_dialogue,
      fortune_guidence: config.characters.the_magician.fortune_guidence
    },
    {
      id: 4,
      image: '/images/characterBackground/priestess.png',
      title: config.characters.the_priestess.title,
      background: '/images/characterBackground/priestess.png',
      personality: config.characters.the_priestess.personality,
      emotion_guidence: config.characters.the_priestess.emotion_guidence,

      colors: ["#5b6c7c", "#aac7c8", "#5e616e", "#25364c", "#e1e6e0"],

      subtitle: config.characters.the_priestess.subtitle,
      description: config.characters.the_priestess.description,

      info: "the_priestess.js",
      import_name: "thePriestess",
      dialogue_background_color: "#aac7c8",
      avatar_image: "/images/The_priestess_avatar.avif",

      intro: config.characters.the_priestess.intro,
      dialogue1: config.characters.the_priestess.dialogue1,
      dialogue2: config.characters.the_priestess.dialogue2,
      interests: config.characters.the_priestess.interests,
      type: config.characters.the_priestess.type,

      fortune_dialogue: config.characters.the_priestess.fortune_dialogue,
      fortune_guidence: config.characters.the_priestess.fortune_guidence

    }
  ];
};

// 导出一个函数，根据当前语言返回角色数据
export const getCharacters = (lang = 'en') => getCharactersData(lang);

// 为向后兼容性，导出一个基于当前URL参数的角色数组
const getLangFromURL = () => {
  if (typeof window === 'undefined') return 'en';
  return new URLSearchParams(window.location.search).get('lang') || 'en';
};

export const characters = getCharactersData(getLangFromURL());